import React from 'react';

export default function Button({
  children,
  onClick,
  type = 'button',
  variant = 'primary',
  size = 'md',
  disabled = false,
  className = '',
  ...props
}) {
  const baseStyles = 'font-semibold rounded-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-soft hover:shadow-medium active:shadow-soft active:scale-[0.98]';

  const variants = {
    primary: 'bg-gradient-to-r from-primary to-secondary hover:from-secondary hover:to-primary text-white',
    secondary: 'bg-gray-100 hover:bg-gray-200 text-gray-900 border border-gray-300',
    accent: 'bg-gradient-to-r from-accent to-warning hover:from-warning hover:to-accent text-white shadow-glow',
    success: 'bg-success hover:bg-primary text-white',
    danger: 'bg-error hover:bg-red-700 text-white',
    outline: 'border-2 border-primary text-primary hover:bg-primary hover:text-white bg-white'
  };

  const sizes = {
    sm: 'px-4 py-2 text-sm min-h-touch',
    md: 'px-6 py-3 text-base min-h-touch',
    lg: 'px-8 py-4 text-lg min-h-btn-lg'
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
